import { render, staticRenderFns } from "./usersetting_page.vue?vue&type=template&id=630f599c"
import script from "./usersetting_page.vue?vue&type=script&lang=js"
export * from "./usersetting_page.vue?vue&type=script&lang=js"
import style0 from "./usersetting_page.vue?vue&type=style&index=0&id=630f599c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports